import React from 'react'
import Slider from '../component/Slider/slider'
import Preloader from '../component/Preloder/preloader'
import PhotoSecTwo from '../photoSection/PhotoSecTwo'
import { slides } from '../data/MainData'
import PhotoSecThree from '../photoSection/PhotoSecThree'
import PhotoCaro from '../component/PhotoCaro'
import PhotSecFour from '../photoSection/PhotoSecFour'
import Facebok from '../component/Facebok'


function Photography () {
  return (
    <div>
        {<Preloader/>}
        {<Slider
          slideData={slides}
        />}
        {<PhotoSecTwo/>}
        {<PhotoCaro/>}
        {<PhotoSecThree/>}
         {<Facebok/>}
        {<PhotSecFour/>}
       
    </div>
  )
}

export default Photography